import { AIRecommendation } from "./AIRecommendation";
import { GreenCertification } from "./GreenCertification";
import { RoomPricing } from "./RoomPricing";
import { Transaction } from "./Transaction";

export interface Hotels {
    hotelId: number;
    hotelName: string;
    location: string;
    totalRooms: number;
    rating: number;
    contactEmail: string;
    contactPhone: string;
    createdAt: Date;
    airecommendations: AIRecommendation[];
    greenCertifications: GreenCertification[];
    transactions: Transaction[];
  }
  
  export const initializedHotel: Hotels = {
    hotelId: 0,
    hotelName: '',
    location: '',
    totalRooms: 0,
    rating: 0,
    contactEmail: '',
    contactPhone: '',
    createdAt: new Date(),
    airecommendations: [], // Initialize as an empty array
    greenCertifications: [], // Initialize as an empty array
    transactions: [], // Initialize as an empty array
  };
    
  

 


  

    



